import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function fetchAllAgreementTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_BEGIN,
    });

    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=AGREEMENT`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAllAgreementTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllAgreementTemplatePending: true,
        fetchAllAgreementTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllAgreementTemplatePending: false,
        fetchAllAgreementTemplateError: null,
        agreementTemplates: action.data,
        template: null,
      };

    case TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllAgreementTemplatePending: false,
        fetchAllAgreementTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllAgreementTemplateError: null,
      };

    default:
      return state;
  }
}
